/**
 * Идентификатор этого клиента — вкладки в браузере или запущенного приложения.
 *
 * Нужен звонкам: identity участника в LiveKit собрана из userId, поэтому второе устройство того же
 * человека не присоединяется к комнате, а вытесняет первое, и собеседник теряет разговор. Сервер
 * помнит, какому клиенту звонок принадлежит, и сравнивает с этим значением — отсюда «звонок открыт
 * на другом устройстве» с кнопкой переноса вместо тихой драки за комнату.
 *
 * `sessionStorage`, а не `localStorage`: две вкладки одного браузера — это два разных клиента, и
 * общий на браузер идентификатор снова сделал бы их неразличимыми. Переживать перезагрузку он при
 * этом обязан — иначе после F5 вкладка выглядела бы новым устройством и отбирала бы у себя же
 * звонок.
 */
const STORAGE_KEY = 'tp-call-client-session';

let cached: string | null = null;

const generate = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `s${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;

export const getClientSessionId = (): string => {
  if (cached) {
    return cached;
  }

  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      cached = stored;
      return stored;
    }
    const created = generate();
    sessionStorage.setItem(STORAGE_KEY, created);
    cached = created;
    return created;
  } catch {
    // Приватный режим или переполненное хранилище: идентификатор живёт только в памяти. Тогда
    // перезагрузка выглядит новым клиентом — неприятно, но лучше, чем упасть на звонке.
    cached = cached ?? generate();
    return cached;
  }
};
